class ProRegisterAutoHeight {
  constructor () {
    this.init();
  }

  _checkWindowSize () {
    return (window.innerWidth > 989);
  }

  _setHeight () {
    const element = document.querySelector('main:has(.wpdapp-custom-container)');
    if (element) {
      const formContainer = element.querySelector('#wpdMainContainer');
      if(!formContainer) {
        return;
      }
      if (this._checkWindowSize()) {
        if (formContainer) {
          formContainer.style.maxHeight = window.getComputedStyle(element, '::before').getPropertyValue('height');
        }
      } else {
        formContainer.style.removeProperty('max-height');
      }
    }
  }

  init () {
    document.addEventListener('DOMContentLoaded', this._setHeight.bind(this));
    window.addEventListener('resize', this._setHeight.bind(this));
  }
}

new ProRegisterAutoHeight();